import classNames from 'classnames';
import React from 'react';

import {BlockSkeleton} from '@udemy/react-reveal-components';

import styles from './value-prop-skeleton.module.less';

/** Sized shell that forces BlockSkeleton to fill its parent (default is 4.8rem wide). */
const SkeletonBlock = ({className}: {className: string}) => (
    <div className={className}>
        <BlockSkeleton className={styles['fill']} />
    </div>
);

/**
 * One entry per complete-revamp value prop. Keys are the config ids so the
 * placeholder count stays in step with the rows that eventually render.
 */
const SKELETON_ROWS = ['skills', 'practice', 'plan'];

/** Full-width body lines per row. A shorter final line is appended after these. */
const BODY_LINES = ['line-1', 'line-2', 'line-3', 'line-4', 'line-5'];

/**
 * ### ValuePropSkeleton
 *
 * Loading state for the complete-revamp value props. Mirrors the loaded layout —
 * three alternating image/text rows — so the section does not shift when the real
 * content arrives.
 */
export const ValuePropSkeleton = () => (
    <div className={styles['wrapper']} data-testid="value-prop-skeleton">
        {SKELETON_ROWS.map((rowKey) => (
            <div key={rowKey} className={styles['row']} data-testid="value-prop-skeleton-row">
                <div className={styles['column']}>
                    <SkeletonBlock className={styles['image']} />
                </div>
                <div className={classNames(styles['column'], styles['text'])}>
                    <SkeletonBlock className={styles['heading']} />
                    <div className={styles['lines']}>
                        {BODY_LINES.map((lineKey) => (
                            <SkeletonBlock key={lineKey} className={styles['line']} />
                        ))}
                        <SkeletonBlock
                            className={classNames(styles['line'], styles['line-short'])}
                        />
                    </div>
                </div>
            </div>
        ))}
    </div>
);
